import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { mediaQuery } from '../../../helpers/media.js';

var _a, _b;
var CarouselContainer = styled.div({
    width: "100%",
});
var CarouselHeader = styled.div({
    display: "flex",
    alignItems: "center",
    position: "relative",
    paddingTop: tokens.spacing[6],
});
var Menu = styled.menu((_a = {
        display: "flex",
        gap: tokens.spacing[6],
        margin: "0 ".concat(tokens.spacing[6], " ").concat(tokens.spacing[5], " auto")
    },
    _a[mediaQuery.m.min] = {
        marginRight: "0",
    },
    _a));
var ArrowButton = styled.button({
    padding: 0,
    height: "24px",
    background: "none",
    color: tokens.color.airJordan.p,
    cursor: "pointer",
});
var CarouselRow = styled.div({
    display: "flex",
    alignItems: "flex-start",
    scrollBehavior: "smooth",
    scrollSnapType: "x mandatory",
    width: "100%",
    scrollbarWidth: "none",
}, {
    "::-webkit-scrollbar": {
        display: "none",
    },
}, {
    overflowX: "scroll",
    '@supports(overflow-inline: "scroll")': {
        overflowX: "initial",
        overflowInline: "scroll",
    },
});
var CarouselItem = styled.div((_b = {
        flex: "0 0 146px",
        scrollSnapAlign: "start",
        height: "100%",
        "& + &": {
            marginLeft: tokens.spacing[5],
        }
    },
    _b[mediaQuery.m.min] = {
        flex: "0 0 220px",
    },
    _b["& > *"] = {
        width: "initial !important",
    },
    _b));

export { ArrowButton, CarouselContainer, CarouselHeader, CarouselItem, CarouselRow, Menu };
//# sourceMappingURL=Carousel.styles.js.map
